export default "__VITE_ASSET__8Mja6lqj__"